import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import get from 'lodash/get'
import flowRight from 'lodash/flowRight'

import { ErrorView, Loading } from '@fielded/shared-ui'

import withConfig from '../../../../../../van-shared/hoc/withConfig'
import { withApi } from '../../../../../../common/ApiProvider'
import { withUser } from '../../../../../../common/AuthenticationProvider'
import withMasterData from '../../../../common/withMasterData'
import withShipment from '../../../../common/WithShipmentWrapper'
import { batchIdToProductId } from '../../../../common/utils'
import { loadPickList } from '../../../../../../root/reducers/shipments/pick-list'
import { selectProducts } from '../../../../../../root/reducers/shipments/master-data'
import { useAmplitudeAnalytics } from '../../../../../../common/analytics-tracking/AmplitudeAnalyticsProvider'

import LMDDeliveryDetail from './LMDDeliveryDetail'

const LMDDeliveryDetailContainer = ({
  api,
  user,
  config,
  match,
  shipment
}) => {
  const dispatch = useDispatch()
  const productsFromStore = useSelector(selectProducts)
  const history = useHistory()
  const trackingHandler = useAmplitudeAnalytics()

  const [error, setError] = useState()
  const [loading, setLoading] = useState(true)
  const [productsMap, setProductsMap] = useState(new Map())
  const [appPrograms, setAppPrograms] = useState({})
  const [sourceName, setSourceName] = useState('')

  // Shipment here is coming from withShipment HOC
  const delivery = shipment

  const initialize = async () => {
    try {
      await dispatch(loadPickList(delivery, productsFromStore, user))

      const productIds = Object.keys(delivery.counts).map(batchId => batchIdToProductId(batchId))
      const products = await api.product.getByIds(productIds)
      const productsMap = products.reduce(
        (map, p) => map.set(p._id, p), new Map()
      )
      const appPrograms = await api.program.list()
      const origin = await api.location.get(delivery.origin.id)
      const sourceName = get(origin, 'name', delivery.origin.id)

      setProductsMap(productsMap)
      setAppPrograms(appPrograms)
      setSourceName(sourceName)

      trackingHandler.shipment.viewed({ shipment })
    } catch (e) {
      setError(e)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    initialize()
  }, [])

  if (error) {
    return <ErrorView title='Shipment' error={error} />
  }

  if (loading) {
    return <Loading />
  }

  return (
    <LMDDeliveryDetail
      user={user}
      history={history}
      config={config}
      delivery={delivery}
      productsMap={productsMap}
      appPrograms={appPrograms}
      sourceName={sourceName}
    />
  )
}

const withHOCs = flowRight(
  withApi,
  withUser,
  withConfig,
  withMasterData,
  withShipment
)

export default withHOCs(LMDDeliveryDetailContainer)
